export type User = {
  id: number
  name: string
  email: string
  role: UserRole
  departments?: {
    departmentId: number
    role: number
    title: string
  }[]
  createTs: string | Date | null
  updateTs: string | Date | null
}
export enum UserRole {
  Viewer = 1,
  Contributor = 2,
  Admin = 3,
  Officiator = 4,
}
